<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col-12 col-md-6">
                    <h1 class="text-white pt-3 px-3">หน้าจัดการราคาขนส่ง</h1>
                    <p
                        class="text-white pb-3 px-3"
                    >เพิ่ม แก้ไข ลบราคาขนส่ง และแสดงตารางรายละเอียดราคาขนส่งทั้งหมดที่มีอยู่</p>
                </div>
            </div>
        </base-header>
        <BlockUI v-if="loader.busy">
            <div class="loader"></div>
        </BlockUI>
        <div class="container-fluid mt--7 mb-5">
            <div class="row">
                <div class="col-12 col-md-12 col-lg-12 col-xl-12 m-auto">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">เลือกขนส่ง</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <DetailsCourier
                                ref="detailsCourier"
                                :rateManagement="true"
                                :inputCourier="inputCourier"
                                :validateData="validateData"
                                :permission="{isGen: false}"
                                :isEdit="false"
                                :isWho="isWho()"
                            />
                            <hr class="my-4" />
                        </template>
                        <h4 class="mb-4">จัดการขนส่งร้านค้า</h4>
                        <SelectTypeFilter :search="search" :disabledPos="search.underShop === 'ALLSUPERADMIN' ? true : false" />
                        <SearchRateManagement
                            :disablePackage="search.underShop === 'ALLSUPERADMIN' ? true : false"
                            ref="searchRateManagement" 
                            :search="search"
                            @searchShop="searchShop"
                        />

                        <h3 class="mb-4">จำนวนร้านค้าที่เลือกทั้งหมด {{ (this.$refs.tableReteManagement) ? this.$refs.tableReteManagement.selectedShop.length : 0 }} รายการ</h3>

                        <TableReteManagement :disabledForSuperAdmin="search.underShop === 'ALLSUPERADMIN' ? true : false" ref="tableReteManagement" :itemRateManagement="itemRateManagement" />

                        <div class="row py-4 justify-content-end">
                            <div class="col-4 col-md-4 col-lg-4 col-xl-2">
                                <button type="button" class="btn btn-secondary btn-block btn-icon py-3" @click="reloadPage()">ยกเลิก</button>
                            </div>
                            <div class="col-4 col-md-4 col-lg-4 col-xl-2">
                                <!-- <button 
                                    type="button" 
                                    class="btn btn-success btn-block btn-icon py-3" 
                                    :disabled="(this.$refs.tableReteManagement) ? this.$refs.tableReteManagement.selectedShop.length < 1 : false"
                                    @click="createCourierForShopRateManagement()"
                                > -->
                                <button 
                                    type="button" 
                                    class="btn btn-success btn-block btn-icon py-3" 
                                    :disabled="(this.$refs.tableReteManagement) ? this.$refs.tableReteManagement.selectedShop.length < 1 : false"
                                    @click="createCourierForShop()"
                                >
                                    เพิ่มขนส่งที่เลือก
                                </button>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import DetailsCourier  from '@/components/custom/transport/inter/DetailsCourier'
import SelectTypeFilter  from '@/components/custom/ratemanagement/SelectTypeFilter'
import SearchRateManagement  from '@/components/custom/ratemanagement/SearchRateManagement'
import TableReteManagement  from '@/components/custom/ratemanagement/TableReteManagement'
import { getCourierInterById, searchShopForRateManagement , createCourierRateManagement } from "@/axios/courier.js";
import { showConfirmSuccessModal , showErrorModal } from "@/components/modalNotification.js";
import CourierRules from '@/constants/CourierRules'


export default {
    name:"ratemanagement",
    components:{
        DetailsCourier,
        SelectTypeFilter,
        SearchRateManagement,
        TableReteManagement
    },
    data(){
        return{
            tempSearchAction: 'SHOP',
            loader: {
                busy: true
            },
            search:{
                typeFilter: 'FILTER',
                courierKey: '',
                rateCode: '',
                underShop: null,
                packageShop: null,
                shopCode: '',
                shopCodeArray: [],
                forceCreate: false
            },
            itemRateManagement: [],
            inputCourier: {
                allowedCourier: [],
                price: 0,
                price_min: 0,
                rate_max_discount: 0,
                service_min: 0,
                service: 0,
                rate_min: 0,
                rate: 0,
                descriptionCouier: "",
                courierName: "",
                courierKey: "",
                effective_date: "",
                expired_date: "",
                nameOfPic: "",
            },
            validateData: {
                submitted: false,
                checkInput: {
                    courierKey: null
                }
            }
        }
    },
    beforeCreate() {
        this.userLogin = JSON.parse(localStorage.getItem("user"));
    },
    async mounted() {
        // await this.getCourierByIdAndRole()
        getCourierInterById( this.$route.params.Id ).then( dataCourier => {
            this.loader.busy = false;
            this.inputCourier.allowedCourier = dataCourier.allowedCourier
            this.inputCourier.courierKey = dataCourier.courierKey
            this.inputCourier.courierName = dataCourier.courierName
            this.inputCourier.descriptionCouier = dataCourier.descriptionCouier
            this.inputCourier.effective_date = dataCourier.effective_date
            this.inputCourier.expired_date = dataCourier.expired_date
            this.inputCourier.id = dataCourier.id
            this.inputCourier.effective_date  = dataCourier.effective_date
            this.inputCourier.expired_date =  dataCourier.expired_date
            this.inputCourier.nameOfPic = dataCourier.nameOfPic
            this.inputCourier.price = dataCourier.price
            this.inputCourier.price_min = dataCourier.price_min
            this.inputCourier.rate_min = dataCourier.rate_min
            this.inputCourier.rate = dataCourier.rate
            this.inputCourier.rate_max_discount = dataCourier.rate_max_discount
            this.inputCourier.service_min = dataCourier.service_min
            this.inputCourier.service = dataCourier.service
            this.loader.busy = false;
        }).catch(e => {
            showErrorModal( e )
            this.loader.busy = false;
        });
    },
    methods: {
        isWho() {
            return this.userLogin.role;
        },
        searchShop(){
            this.$refs.searchRateManagement.isLoadSearch = true
            this.$http.get( this.$API_URL + `/inter/list/courier` , {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            params: {
                courier_key: this.search.courierKey,
                default_courier_code: this.search.rateCode,
                under_by: this.search.underShop,
                package: this.search.packageShop,
                shop_code: this.search.typeFilter === 'SPECIFY' ? this.search.shopCodeArray : []
            }
            }).then( res => {
                if (!res.data.status) {
                    showErrorModal( res.data.error.message )
                    return false
                }
                this.$refs.searchRateManagement.isLoadSearch = false
                this.itemRateManagement = res.data.data
                this.tempSearchAction = this.search.underShop ? this.search.underShop : 'SHOP'
            }).catch(e => {
                showErrorModal( e )
                this.$refs.searchRateManagement.isLoadSearch = false
            });
        },
        createCourierForShop(){
            this.loader.busy = true;
            const form_params = {
                code_group: this.$refs.tableReteManagement.selectedShop,
                courier_inter_id: this.inputCourier.id,
                type: this.tempSearchAction,
                force: this.search.forceCreate
            }
            const header = {
                headers: {
                    token: localStorage.getItem('access_token')
                }
            }

            this.$http.post(this.$API_URL + '/inter/list/courier', form_params, header).then((res) => {
                if(res.data.status) {
                    this.loader.busy = false;
                    showConfirmSuccessModal('เพิ่มขนส่งให้ร้านค้าสำเร็จ')
                }else {
                    showErrorModal('เกิดข้อผิดพลาดกรุณาติดต่อเจ้าหน้าที่')
                    this.loader.busy = false;
                }
            }).catch(e => {
                showErrorModal(e)
                this.loader.busy = false;
            });
            // createCourierRateManagement( this.$refs.tableReteManagement.selectedShop , this.inputCourier.rateCode , this.search.forceCreate ).then( res => {
            //     this.loader.busy = false;
            //     if(res.status){
            //         showConfirmSuccessModal('เพิ่มขนส่งให้ร้านค้าสำเร็จ')
            //     }
            // }).catch(e => {
            //     showErrorModal( e )
                // this.loader.busy = false;
            // });
            // console.log('this.$refs.tableReteManagement.selectedShop: ', this.$refs.tableReteManagement.selectedShop)
            // console.log('this.inputCourier.rateCode: ', this.inputCourier.id)
        },
        reloadPage() {
            location.reload()
        },
        setFormatDateTimeLocal( dateTime ){
            return moment(dateTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DDTHH:mm")
        },
        setFormatDateTimeSaveDatabase( dateTime ){
            return moment(dateTime, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD HH:mm:ss")
        }
    }
}
</script>